import { useState } from 'react';
import { Typography } from '@mui/material';
import { ProjectDto } from 'tdc-web-backend/projects/schemas';
import { CompanyRole } from 'tdc-web-backend/enums/enums';
import { useTranslation } from 'react-i18next';
import ActionMenu, { IActionMenuItem } from '../../../../../../components/action-menu/ActionMenu';
import useAuth from '../../../../../../utils/hooks/useAuth';
import PreviousRequestModal from './components/PreviousRequestModa';
import NewRequestModal from './components/NewRequestModal';
import useUserCompany from '../../../../../../utils/hooks/useUserCompany';
import useMode from '../../../../../../utils/hooks/useMode';
import { EnumMode } from '../../../../../../utils/context/Mode.context';

interface IFinancingRequestProps {
  project: ProjectDto;
}

const FinancingRequest = ({ project }: IFinancingRequestProps) => {
  const [isNewRequestOpen, setIsNewRequestOpen] = useState(false);
  const [isPreviousRequestsOpen, setIsPreviousRequestsOpen] = useState(false);
  const { t } = useTranslation();
  const { mode } = useMode();

  const {
    authData: { userData },
  } = useAuth();

  const menu: IActionMenuItem[] = [
    {
      key: 'new',
      text: <Typography variant="bodySemiBold2">{t('financing.newRequest')}</Typography>,
      onClick: () => setIsNewRequestOpen(true),
    },
    {
      key: 'previous_requests',
      text: <Typography variant="bodySemiBold2">{t('financing.previousRequests')}</Typography>,
      onClick: () => setIsPreviousRequestsOpen(true),
    },
  ];

  let text = t('financing.getPaidNow');
  if (mode === EnumMode.Client) {
    text = t('financing.deferPayment');
  }

  return (
    <>
      <ActionMenu text={text} menu={menu} />

      {isNewRequestOpen && (
        <NewRequestModal
          isOpen={isNewRequestOpen}
          setIsOpen={setIsNewRequestOpen}
          projectId={project.id}
        />
      )}

      {isPreviousRequestsOpen && (
        <PreviousRequestModal
          isOpen={isPreviousRequestsOpen}
          setIsOpen={setIsPreviousRequestsOpen}
          projectId={project.id}
          companyId={userData?.membership?.company}
        />
      )}
    </>
  );
};

export default FinancingRequest;
